var map = {
	"./App.vue": [
		"3dfd"
	],
	"./components/AppButton.vue": [
		"45c2",
		"chunk-e5d71fe8"
	],
	"./components/AppInput.vue": [
		"97f7",
		"chunk-eff7696e"
	],
	"./components/AppLayout.vue": [
		"01de",
		"chunk-0d79b007"
	],
	"./components/AppRadioItem.vue": [
		"0387",
		"chunk-477bda01"
	],
	"./components/AppText.vue": [
		"2a0a",
		"chunk-4eefb03c"
	],
	"./components/BuyModal.vue": [
		"4e39"
	],
	"./components/IconRefresh.vue": [
		"f4fb",
		"chunk-2d22cec0"
	],
	"./components/IconUser.vue": [
		"002d",
		"chunk-2d0a2d68"
	],
	"./components/ItemThumbnail.vue": [
		"5a7a"
	],
	"./components/ListingModal.vue": [
		"03667"
	],
	"./components/LoaderModal.vue": [
		"5468"
	],
	"./components/LoginModal.vue": [
		"4ed9"
	],
	"./components/PollForm.vue": [
		"573b",
		"chunk-2d0c8da7"
	],
	"./components/PollList.vue": [
		"2ce6",
		"chunk-2d0bdb98"
	],
	"./components/ReLoginModal.vue": [
		"9280"
	],
	"./components/ShowWalletBalance.vue": [
		"cde4"
	],
	"./components/TypeItem.vue": [
		"0f37",
		"chunk-997b1d7e"
	],
	"./components/TypeList.vue": [
		"23fb",
		"chunk-2d0b27b3"
	],
	"./components/Wallet.vue": [
		"d72e",
		"chunk-1e5d2fbc"
	],
	"./views/About.vue": [
		"f820"
	],
	"./views/Buy.vue": [
		"54ec"
	],
	"./views/Index.vue": [
		"d504",
		"chunk-2d21e30b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cff8";
module.exports = webpackAsyncContext;